export default __webpack_public_path__ + "static/media/emotions.62273253.gif";